import * as i0 from "@angular/core";
import * as i1 from "../modal-base/components/modal-base.component";
import * as i2 from "../modal-base/components/simple-modal-footer.component";
import * as i3 from "../modal-base/components/simple-modal-header.component";
function RefreshRequiredModalComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 0);
} }
/**
 * Refresh Required Modal Component
 *
 * Displays a blocking modal prompting the current tab to refresh.
 */
export class RefreshRequiredModalComponent {
    constructor() {
        this.modalOpen = false;
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
    }
}
RefreshRequiredModalComponent.ɵfac = function RefreshRequiredModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RefreshRequiredModalComponent)(); };
RefreshRequiredModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RefreshRequiredModalComponent, selectors: [["ycn-refresh-required-modal"]], inputs: { refreshMessage: "refreshMessage" }, standalone: false, decls: 7, vars: 7, consts: [[1, "modal-backdrop", "show"], [3, "open"], [3, "header", "showCloseButton"], [1, "modal-body"], [1, "modal-section"], [1, "modal-message", 3, "innerHTML"], [3, "showCancelButton", "showSubmitButton"]], template: function RefreshRequiredModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, RefreshRequiredModalComponent_Conditional_0_Template, 1, 0, "div", 0);
        i0.ɵɵelementStart(1, "ycn-modal-base", 1);
        i0.ɵɵelement(2, "ycn-simple-modal-header", 2);
        i0.ɵɵelementStart(3, "div", 3)(4, "div", 4);
        i0.ɵɵelement(5, "div", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(6, "ycn-simple-modal-footer", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.modalOpen ? 0 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Refresh Required")("showCloseButton", false);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("innerHTML", ctx.refreshMessage, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance();
        i0.ɵɵproperty("showCancelButton", false)("showSubmitButton", false);
    } }, dependencies: [i1.ModalBaseComponent, i2.SimpleModalFooterComponent, i3.SimpleModalHeaderComponent], encapsulation: 2 });
